import { DividerList } from '@mews-commander/ui';
import { DefaultPolicySection } from './DefaultPolicySection';
import { PaymentConfigurationSection } from './PaymentConfigurationSection';

export const RateGroupFormPaymentPoliciesFields = () => (
    <DividerList spacing="400">
        <PaymentConfigurationSection />
        <DefaultPolicySection />
    </DividerList>
);
